import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AmountUtils, cn, ColorUtils, DateUtils } from '@shared/utils';
import { type TransactionResponse } from '@shared/api/rest/transactions';
import { Table, TableCellType } from '@shared/widgets';

interface ITransactionTableProps {
  isLoading?: boolean;
  data: TransactionResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}

export const TransactionTable = (props: ITransactionTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      t('tables.transaction.columns.status'),
      t('tables.transaction.columns.ref'),
      t('tables.transaction.columns.date'),
      t('tables.transaction.columns.description'),
      t('tables.transaction.columns.amount'),
      t('tables.transaction.columns.originalAmount'),
      t('tables.transaction.columns.card'),
    ],
    [t],
  );
  return (
    <Table
      isLoading={props.isLoading}
      isScrollable
      columns={columns}
      items={props.data.map((row) => {
        const color = ColorUtils.getTransactionStatusStyles(row.status);
        return [
          {
            type: TableCellType.Custom,
            value: (
              <div className={cn('whitespace-nowrap px-2 py-1 text-center font-normal', color.bg, color.text)}>
                {t(`statuses.cardTransaction.${row.status}`)}
              </div>
            ),
          },
          { type: TableCellType.Text, value: row.ref },
          { type: TableCellType.Text, value: DateUtils.formatDate(row.date) },
          { type: TableCellType.Text, value: row.description },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.amountBaseCurrency, row.baseCurrency)}` },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.amount, row.currency)}` },
          { type: TableCellType.Text, value: row.cardNumber },
        ];
      })}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
